
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/ai-engineering",
      function () {
        return require("private-next-pages/books/ai-engineering.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/ai-engineering"])
      });
    }
  